import LoaderCircle from './LoaderCircle'

const LoadWrapper = ({ isLoading = false, children }) => {
  if (isLoading) {
    return (
      <div className="load-wrapper">
        <LoaderCircle />
      </div>
    )
  }

  return children
}

export default LoadWrapper
